/*
 * @flow strict
 * Copyright (C) 2013 MetaBrainz Foundation
 *
 * This file is part of MusicBrainz, the open internet music database,
 * and is licensed under the GPL version 2, or (at your option) any
 * later version: http://www.gnu.org/licenses/gpl-2.0.txt
 */

import * as flags from '../../../flags.js';
import * as modes from '../../../modes.js';

import GuessCaseHandler from './Base.js';

// Place specific GuessCase functionality
class GuessCasePlaceHandler extends GuessCaseHandler {
  /*
   * Delegate function which handles words not handled
   * in the common word handlers.
   */
  doWord(): boolean {
    (
      this.doIgnoreWords() ||
      modes[this.modeName].doWord() ||
      this.doNormalWord()
    );
    flags.context.number = false;
    return true;
  }

  // Guesses the sortname for place aliases
  guessSortName(inputString: string): string {
    return this.sortCompoundName(
      inputString,
      (inputString) => this.moveArticleToEnd(inputString),
    );
  }
}

export default GuessCasePlaceHandler;
